import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { MODELER_SERVICE } from '@eggplant/api-hosts'
import type {
  CloneTestCaseParams,
  TestCase
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  testCaseId: string
  modelId: string
  params: CloneTestCaseParams
  onSuccess: (response: TestCase) => void
  children?: () => ReactElement
}

const CloneModelerModelTestCaseRequest = ({
  testCaseId,
  modelId,
  params,
  onSuccess,
  children
}: Props) => {
  const url = `${MODELER_SERVICE}/models/${modelId}/test_cases/${testCaseId}/clone`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='post'
      onSuccess={onSuccess}
      params={params}
      url={url}
    />
  )
}

export default CloneModelerModelTestCaseRequest
